import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { Switch } from "@/components/ui/switch";
import { Settings, Bot, Save } from "lucide-react";

export default function WorkflowConfigPanel({ config, setConfig, onSave }) {
  return (
    <Card className="mb-6" data-testid="workflow-config-panel">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Settings className="w-5 h-5 text-primary" />
          Automated Workflow Settings
        </CardTitle>
        <CardDescription>Configure AI-powered candidate shortlisting</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center justify-between p-4 border rounded-lg">
          <div className="flex items-center gap-3">
            <Bot className="w-5 h-5 text-primary" />
            <div>
              <Label className="font-medium">AI Recommendation Engine</Label>
              <p className="text-sm text-gray-600">Let AI analyze and recommend shortlist candidates</p>
            </div>
          </div>
          <Switch
            checked={config.ai_recommendation_enabled}
            onCheckedChange={(checked) => setConfig({ ...config, ai_recommendation_enabled: checked })}
            data-testid="ai-recommendation-switch"
          />
        </div>

        <div className="flex items-center justify-between p-4 border rounded-lg">
          <div>
            <Label className="font-medium">Auto-Shortlist Candidates</Label>
            <p className="text-sm text-gray-600">Automatically flag candidates meeting threshold</p>
          </div>
          <Switch
            checked={config.auto_shortlist_enabled}
            onCheckedChange={(checked) => setConfig({ ...config, auto_shortlist_enabled: checked })}
            data-testid="auto-shortlist-switch"
          />
        </div>

        {config.auto_shortlist_enabled && (
          <div className="p-4 border rounded-lg bg-gray-50">
            <Label className="font-medium mb-3 block">
              Shortlist Threshold: {config.auto_shortlist_threshold}%
            </Label>
            <Slider
              value={[config.auto_shortlist_threshold]}
              onValueChange={(value) => setConfig({ ...config, auto_shortlist_threshold: value[0] })}
              min={50}
              max={100}
              step={5}
              className="mb-2"
              data-testid="threshold-slider"
            />
            <p className="text-xs text-gray-600">
              Candidates scoring {config.auto_shortlist_threshold}% or above will be recommended for shortlisting
            </p>
          </div>
        )}

        <Button onClick={onSave} className="w-full bg-primary hover:bg-primary/90" data-testid="save-workflow-btn">
          <Save className="w-4 h-4 mr-2" /> Save Workflow Configuration
        </Button>
      </CardContent>
    </Card>
  );
}
